var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.open
    ? _c("tr", { staticClass: "concordance-details" }, [
        _c("td", { attrs: { colspan: _vm.colspan } }, [
          _c(
            "div",
            { staticClass: "concordance-details-wrapper" },
            [
              _vm.loading
                ? _c(
                    "p",
                    { class: { "text-danger": !!_vm.error } },
                    [
                      _c("Spinner", { attrs: { inline: "" } }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("results.table.loading")) +
                          "\n\t\t\t"
                      ),
                    ],
                    1
                  )
                : _vm.error
                ? _c("p", { staticClass: "text-danger" }, [
                    _c("span", { staticClass: "fa fa-exclamation-triangle" }),
                    _vm._v(" "),
                    _c("span", { domProps: { innerHTML: _vm._s(_vm.error) } }),
                  ])
                : _vm.context
                ? [
                    _vm.hasRelations && !_vm.isParallel
                      ? [
                          _vm.sentenceAvailable
                            ? _c(
                                "label",
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.sentenceShown,
                                        expression: "sentenceShown",
                                      },
                                    ],
                                    staticClass: "show-sentence-checkbox",
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(_vm.sentenceShown)
                                        ? _vm._i(_vm.sentenceShown, null) > -1
                                        : _vm.sentenceShown,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.sentenceShown,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.sentenceShown = $$a.concat([
                                                $$v,
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.sentenceShown = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.sentenceShown = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.sentenceLoading
                                    ? _c("Spinner", {
                                        staticStyle: {
                                          "margin-right": "0.5em",
                                        },
                                        attrs: { inline: "" },
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("results.table.showFullSentence")
                                    ) + "\n\t\t\t\t\t"
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("DepTree", {
                            attrs: {
                              data: _vm.data,
                              fullSentence: _vm.sentenceShown
                                ? _vm.sentence
                                : undefined,
                              mainAnnotation: _vm.mainAnnotation,
                              otherAnnotations: _vm.depTreeAnnotations,
                            },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "p",
                      { attrs: { dir: _vm.dir } },
                      [
                        _vm._l(_vm.addons, function (addon) {
                          return [
                            addon.component
                              ? _c(
                                  addon.component,
                                  _vm._g(
                                    _vm._b(
                                      {
                                        key: addon.name + "_vue",
                                        tag: "component",
                                        class: `addon addon-${addon.name} ${
                                          (addon.props && addon.props.class) ||
                                          ""
                                        }`,
                                      },
                                      "component",
                                      addon.props,
                                      false
                                    ),
                                    addon.listeners
                                  ),
                                  [
                                    addon.content
                                      ? _c("div", {
                                          domProps: {
                                            innerHTML: _vm._s(addon.content),
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                )
                              : _c(
                                  addon.element || "div",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        key: addon.name + "_html",
                                        tag: "component",
                                        class: `addon addon-${addon.name} ${
                                          (addon.props && addon.props.class) ||
                                          ""
                                        }`,
                                        domProps: {
                                          innerHTML: _vm._s(addon.content),
                                        },
                                      },
                                      "component",
                                      addon.props,
                                      false
                                    ),
                                    addon.listeners
                                  )
                                ),
                          ]
                        }),
                        _vm._v(" "),
                        _c("HitContextComponent", {
                          attrs: {
                            tag: "span",
                            dir: _vm.dir,
                            data: _vm.context,
                            html: _vm.html,
                            annotation: _vm.mainAnnotation.id,
                            before: true,
                            after: false,
                            hoverMatchInfos: _vm.hoverMatchInfos,
                          },
                          on: {
                            hover: function ($event) {
                              return _vm.$emit("hover", $event)
                            },
                            unhover: function ($event) {
                              return _vm.$emit("unhover", $event)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("HitContextComponent", {
                          attrs: {
                            tag: "strong",
                            dir: _vm.dir,
                            data: _vm.context,
                            html: _vm.html,
                            annotation: _vm.mainAnnotation.id,
                            bold: "",
                            hoverMatchInfos: _vm.hoverMatchInfos,
                          },
                          on: {
                            hover: function ($event) {
                              return _vm.$emit("hover", $event)
                            },
                            unhover: function ($event) {
                              return _vm.$emit("unhover", $event)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.data.href
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.data.href,
                                  title: "Go to hit in document",
                                  target: "_blank",
                                },
                              },
                              [
                                _c("sup", {
                                  staticClass: "fa fa-link",
                                  staticStyle: { "margin-left": "-5px" },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("HitContextComponent", {
                          attrs: {
                            tag: "span",
                            dir: _vm.dir,
                            data: _vm.context,
                            html: _vm.html,
                            annotation: _vm.mainAnnotation.id,
                            after: true,
                            before: false,
                            hoverMatchInfos: _vm.hoverMatchInfos,
                          },
                          on: {
                            hover: function ($event) {
                              return _vm.$emit("hover", $event)
                            },
                            unhover: function ($event) {
                              return _vm.$emit("unhover", $event)
                            },
                          },
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.detailedAnnotations?.length
                      ? _c(
                          "table",
                          { staticClass: "concordance-details-table" },
                          [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.$t("results.table.property"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    style: `text-align: ${
                                      _vm.dir === "rtl" ? "right" : "left"
                                    }`,
                                    attrs: {
                                      colspan: _vm.data.hit.match.punct.length,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("results.table.value"))
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.detailedAnnotations,
                                function (annot, index) {
                                  return _c(
                                    "tr",
                                    { key: annot.id },
                                    [
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(_vm.$tAnnotDisplayName(annot))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.context.match,
                                        function (token, ti) {
                                          return _c("HitContextComponent", {
                                            key: annot.id + ti,
                                            attrs: {
                                              tag: "td",
                                              data: { match: [token] },
                                              html: _vm.html,
                                              dir: _vm.dir,
                                              punct: false,
                                              highlight: false,
                                              annotation: annot.id,
                                              hoverMatchInfos:
                                                _vm.hoverMatchInfos,
                                            },
                                            on: {
                                              hover: function ($event) {
                                                return _vm.$emit(
                                                  "hover",
                                                  $event
                                                )
                                              },
                                              unhover: function ($event) {
                                                return _vm.$emit(
                                                  "unhover",
                                                  $event
                                                )
                                              },
                                            },
                                          })
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : !_vm.detailedAnnotations?.length
                ? [_c("p", [_vm._v(_vm._s(_vm.$t("results.table.noContext")))])]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }